// Default map view for Czech Republic
export const MAP_CONFIG = {
  center: [15.5, 49.8], // [lon, lat] WGS84
  zoom: 7,
}